const actions = {
    FETCH_APPOINTMENTS: 'FETCH_APPOINTMENTS',
    RESET_APPOINTMENTS: 'RESET_APPOINTMENTS',

    fetchGetAppointmentsAction: (data) => {
        return {
            type: actions.FETCH_APPOINTMENTS,
            data: data
        };
    },

    resetGetAppointmentsFormAction: () => {
        return {
            type: actions.RESET_APPOINTMENTS,
            data: null
        };
    },

};

export default actions;
